"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DualListExtender = function DualListExtender(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list-extended"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiExpandableHeader, {
    title: props.headerTitle,
    isInitiallyExpanded: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selected-assets"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "individual-selection-buttons-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': props.allItemsSelected
    }),
    onClick: props.onAllItemsClicked,
    key: "allButton"
  }, props.textAll), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': !props.allItemsSelected
    }),
    onClick: props.onIndividualItemsClicked,
    key: "individualButton"
  }, props.textSelectIndividually)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("dual-list-extended-container", {
      'hide-dual-list': props.allItemsSelected,
      'show-dual-list': !props.allItemsSelected
    })
  }, /*#__PURE__*/_react["default"].createElement(_index.DualListControlled, {
    selectableItems: props.selectableItems,
    selectedItems: props.selectedItems,
    onSelectAll: props.onSelectAll,
    onSelect: props.onSelect,
    onDeselectAll: props.onDeselectAll,
    onDeselect: props.onDeselect,
    filterable: props.filterable,
    filterLabel: props.filterLabel,
    disabled: props.disabled,
    displayAssignedItemTotals: props.displayAssignedItemTotals,
    assignedItemsText: props.assignedItemsText,
    notAssignedItemsText: props.notAssignedItemsText
  })))));
};

DualListExtender.propTypes = {
  headerTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  textAll: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  textSelectIndividually: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  allItemsSelected: _propTypes["default"].bool,
  onIndividualItemsClicked: _propTypes["default"].func,
  onAllItemsClicked: _propTypes["default"].func,
  selectableItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onSelect: _propTypes["default"].func,
  onDeselect: _propTypes["default"].func,
  onSelectAll: _propTypes["default"].func,
  onDeselectAll: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  filterable: _propTypes["default"].bool,
  displayAssignedItemTotals: _propTypes["default"].bool,
  filterLabel: _propTypes["default"].string,
  assignedItemsText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  notAssignedItemsText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};

var noop = function noop() {};

DualListExtender.defaultProps = {
  headerTitle: 'Insert Title',
  textSelectIndividually: 'Insert selected individually items',
  textAll: 'Insert all selected items',
  displayAssignedItemTotals: true,
  filterLabel: _index.DualListControlled.defaultProps.filterLabel,
  assignedItemsText: '',
  notAssignedItemsText: '',
  onAllItemsClicked: noop,
  onIndividualItemsClicked: noop,
  allItemsSelected: true,
  selectableItems: [],
  selectedItems: [],
  onSelect: noop,
  onDeselect: noop,
  disabled: false,
  filterable: true,
  onSelectAll: noop,
  onDeselectAll: noop
};
var _default = DualListExtender;
exports["default"] = _default;